/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import './Services_details.css';
import { Helmet } from 'react-helmet';
import ScrollReveal from 'scrollreveal';
import { useLocation } from 'react-router-dom';
import Services_website from './components/Services_website';
import Services_MobileApp from './components/Services_MobileApp';
import Services_Portfolio from './components/Services_Portfolio';

export default function Services_Details() {
    const location = useLocation();
    const { service } = location?.state;

    useEffect(() => {
        const sr = ScrollReveal({
            distance: '50px',
            duration: 1000,
            delay: 150,
            reset: true
        });

        // sr.reveal('.home-content, .heading', { origin: 'top' });
        sr.reveal('.content-box, .package-box', { origin: 'bottom' });
        sr.reveal('.heading-main', { origin: 'left' });
        sr.reveal('.cost', { origin: 'right' });
    }, []);

    const renderContent = () => {
        switch (service) {
            case 'website':
                return (
                    <Services_website />
                );
            case 'mobile_app':
                return (
                    <Services_MobileApp />
                );
            case 'portfolio':
                return (
                  <Services_Portfolio />
                );
            default:
                return <div>Please select a service.</div>;
        }
    };

    return (
        <div>
            <Helmet>
                <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
                <title>Services</title>
                <link rel="icon" href={'../assets/Images/cv.png'} />
            </Helmet>
            {renderContent()}
        </div>
    )
}
